export function renderOnTest(_window = window): boolean {
  if (_window.location.href.match('ifit-test') || _window.location.hostname === 'localhost') {
    return true;
  }
  return false;
}
